import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export function isEventOpen(event) {
  return event?.attributes?.isActive === true || event?.attributes?.isActive === 'Aberto';
}

export function filterEventsByStatus(events = [], status = 'all') {
  if (status === 'all') return events;
  return events.filter(event => status === 'open' ? isEventOpen(event) : !isEventOpen(event));
}

export default function EventStatusFilter({ value, onChange }) {
  return (
    <FormControl fullWidth size="small">
      <InputLabel id="event-status-filter-label">Status do evento</InputLabel>
      <Select
        labelId="event-status-filter-label"
        value={value}
        label="Status do evento"
        onChange={event => onChange(event.target.value)}
      >
        <MenuItem value="open">Abertos</MenuItem>
        <MenuItem value="closed">Encerrados</MenuItem>
        <MenuItem value="all">Todos</MenuItem>
      </Select>
    </FormControl>
  );
}
